module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray-14b227759d0c76556a76b6b17b0ea298.png";